import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatGridListModule } from "@angular/material/grid-list";
import { FusePipesModule } from "@fuse/pipes/pipes.module";
import { FuseMaterialIconPickerComponent } from "@fuse/components/material-icon-picker/material-icon-picker.component";
import { MaterialIconPickerDialogComponent } from "./material-icon-picker-dialog.component";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatRippleModule } from "@angular/material/core";
import { FlexLayoutModule } from "@angular/flex-layout";

@NgModule({
    declarations: [FuseMaterialIconPickerComponent, MaterialIconPickerDialogComponent],
    imports: [
        CommonModule,
        FlexLayoutModule,
        MatButtonModule,
        MatIconModule,
        MatRippleModule,
        MatGridListModule,
        FusePipesModule,
    ],
    exports: [FuseMaterialIconPickerComponent, MaterialIconPickerDialogComponent],
})
export class FuseMaterialIconPickerModule {}
